import React from 'react'
import { useContent } from '../../contexts/ContentContext'
import SectionWrapper from '../ui/SectionWrapper'
import SectionLabel from '../ui/SectionLabel'
import LazyImage from '../ui/LazyImage'
import { r2, portraits } from '../../utils/media'

export default function AboutSection() {
  const { about } = useContent()

  const portraitFallback = (
    <div className="w-full h-full flex items-center justify-center text-body font-primary text-color-text">
      {about.photoPlaceholder}
    </div>
  )

  return (
    <SectionWrapper data-section="AboutSection" id="ueber" data-testid="about-section" className="!pt-8 !pb-20 md:!pt-20 md:!pb-20">
      <div className="grid md:grid-cols-2 md:card-grid-gap-lg items-start">

        {/* LEFT COLUMN — Label + desktop portrait (sticky) */}
        <div className="order-1 md:order-none md:sticky md:top-28 md:self-start">
          <SectionLabel text={about.label} />
          <div className="hidden md:block aspect-[3/4] rounded-2xl overflow-hidden bg-color-bg-light w-full max-w-sm mt-6">
            <LazyImage
              src={r2(portraits.p37)}
              alt="Benjamin Kurtz"
              className="w-full h-full object-cover object-top"
              fallback={portraitFallback}
            />
          </div>
        </div>

        {/* RIGHT COLUMN — Headline + mobile portrait + body (single cell so body follows headline directly) */}
        <div className="order-2 md:order-none">
          <h2 className="typography-h2-mobile md:typography-h2 leading-tight mt-2 md:mt-0 mb-6">
            {about.headline}
          </h2>

          {/* Portrait — mobile only, between headline and body */}
          <div className="md:hidden aspect-[16/9] rounded-2xl overflow-hidden bg-color-bg-light w-full mb-10">
            <LazyImage
              src={r2(portraits.p37)}
              alt="Benjamin Kurtz"
              className="w-full h-full object-cover object-top"
              fallback={portraitFallback}
            />
          </div>

          {/* Body */}
          {about.body.map((para, i) => (
            <p key={i} className={`typography-body ${i > 0 ? 'margin-top-sm' : ''}`}>
              {para}
            </p>
          ))}

          <div className="mt-8 border-t border-color-light">
            <p className="typography-label">
              {about.credentialsLabel}
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-2.5 gap-x-4">
              {about.credentials.map((cred, i) => (
                <li key={i} className="flex items-start gap-2">
                  <span className="text-color-primary shrink-0 mt-0.5">—</span>
                  {cred}
                </li>
              ))}
            </ul>
          </div>
        </div>

      </div>
    </SectionWrapper>
  )
}
